<template>
    <div class="row">
        <div class="col-md-6">
                <seccion-datos :titulo="datoslineafacturacion" @cambios="guardar()">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <!-- No podrÃ¡ editarse este campo, solo en la creaciÃ³n -->
                                <div v-if="(id > 0)" class="form-group">
                                    <label>{{ $t('general.empresa') }}&nbsp;</label>
                                        <select disabled class="custom-select form-control-sm" v-model="seleccionado">
                                        <option v-for="empresa in empresas" :key="empresa.id" :value="empresa.id_empresa">
                                        {{empresa.nombre_empresa}}</option>
                                        </select>
                                </div>
                                <div v-else class="form-group">
                                    <label>{{ $t('general.empresa') }}&nbsp;</label>
                                        <select  class="custom-select form-control-sm" v-model="seleccionado">
                                        <option v-for="empresa in empresas" :key="empresa.id" :value="empresa.id_empresa">
                                            {{empresa.nombre_empresa}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="nombre_completo">{{ $t('general.nombre') }}</label>
                                <input :disabled="isDisabled" type="text" class="form-control nombre_completo dato" v-model="nombre_serie"  placeholder="">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label v-if="(no_factura==1 || sistema_verifactu==1) && verifactu==0" for="nombre_completo">{{ $t('general.prefijoregistro') }}</label>
                                <label v-if="no_factura==0 && sistema_verifactu==0" for="nombre_completo">{{ $t('general.prefijofactura') }}</label>
                                <label v-if="verifactu==1" for="nombre_completo">{{ $t('general.prefijoverifactu') }}</label>

                                <input :disabled="isDisabled" type="text" class="form-control nombre_completo dato" v-model="prefijo_factura_serie" placeholder="">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="nombre_completo">{{ $t('general.prefijoabono') }}</label>
                                <input :disabled="isDisabled" type="text" class="form-control nombre_completo dato" v-model="prefijo_abono_serie" placeholder="">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label v-if="(no_factura==1 || sistema_verifactu==1) && verifactu==0" for="nombre_completo">{{ $t('general.digitosregistro') }}</label>
                                <label v-if="no_factura==0 && sistema_verifactu==0" for="nombre_completo">{{ $t('general.digitosfactura') }}</label>
                                <label v-if="verifactu==1" for="nombre_completo">{{ $t('general.digitosverifactu') }}</label>
                                <input :disabled="isDisabled" type="text" class="form-control nombre_completo dato" v-model="digitos_numero_factura" placeholder="">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="nombre_completo">{{ $t('general.inicioserie') }}</label>
                                <input :disabled="isDisabled" type="text" class="form-control nombre_completo dato" v-model="tope_serie"  placeholder="">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="nombre_completo">{{ $t('general.inicioserieabono') }}</label>
                                <input :disabled="isDisabled" type="text" class="form-control nombre_completo dato" v-model="tope_serie_abono"  placeholder="">
                            </div>
                        </div>
                    </div>
            </seccion-datos>
        </div>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: {
        id: {
            type: Number,
            default: 0,
        },
        linea: {
            type: Object,
            default: () => ({}),
        },
        verifactu: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return { 
            no_factura: localStorage.getItem('no_factura'),
            sistema_verifactu: localStorage.getItem('sistema_verifactu'),
            nombre_serie: '',
            prefijo_factura_serie: '',
            digitos_numero_factura: '',
            prefijo_abono_serie: '',
            tope_serie: '',
            tope_serie_abono: '',
            empresas: '',
            seleccionado: '',
            datoslineafacturacion:"Datos línea",
        }  
    },
    methods: {
        async listadoEmpresas() {
            /*  modulos/pwgsapi/index.php/empresas/simple */
            this.$store.dispatch('cambiarCargando', true);
            const api = new PwgsApi;
            const datos = await api.get('empresas/todas');
            this.empresas = datos;
            this.$store.dispatch('cambiarCargando', false);
        },
        async obtenerLineas() {
            if(this.id == 0)return;
            this.$store.dispatch('cambiarCargando', true);
            this.nombre_serie = this.linea.nombre_serie;
            this.prefijo_factura_serie = this.linea.prefijo_factura_serie;
            this.digitos_numero_factura = this.linea.digitos_numero_factura;
            this.prefijo_abono_serie = this.linea.prefijo_abono_serie;
            this.tope_serie = this.linea.tope_serie;
            this.tope_serie_abono = this.linea.tope_serie_abono;
            this.seleccionado = this.linea.empresas_factura_id_empresa;
            this.$store.dispatch('cambiarCargando', false);
        },
        validarPrefijo(prefijo) {
            //  No debe empezar con espacio
            if (/^\s/.test(prefijo)) {
                return "No debe empezar con un espacio en blanco.";
            }
            //  Solo se permite UN espacio como mÃ¡ximo
            const espacios = prefijo.match(/\s/g);
            if (espacios && espacios.length > 1) {
                return "Solo se permite un espacio en blanco.";
            }
            // No debe contener letras minÃºsculas
            if (/[a-z]/.test(prefijo)) {
                return "No se permiten letras minúsculas.";
            }
            //  Solo caracteres permitidos: A-Z, nÃºmeros, espacio opcional, -, _, /, .
            if (!/^[A-Z0-9._/ -]+$/.test(prefijo)) {
            return "Solo se permiten letras A-Z, números, un espacio y los caracteres - _ / .";
            }
            //  Validar que no existan dos caracteres especiales o mezcla incorrecta (opcional)
            return "Prefijo válido";
        },
        async guardar() {
            // Capturamos la ruta exacta desde la que se pulsa "guardar"
            const rutaOrigen = this.$route.fullPath;

            if (this.verifactu != 1 || (this.verifactu == 1 && !this.id > 0)) {
                const subidadatos = { 
                    empresas_factura_id_empresa: this.seleccionado, 
                    nombre_serie: this.nombre_serie, 
                    prefijo_factura_serie: this.prefijo_factura_serie, 
                    prefijo_abono_serie: this.prefijo_abono_serie, 
                    digitos_numero_factura: this.digitos_numero_factura, 
                    tope_serie: this.tope_serie, 
                    tope_serie_abono: this.tope_serie_abono,
                    verifactu_serie: this.verifactu 
                };
                const api = new PwgsApi;

                let errorprefijofacturaserie = this.validarPrefijo(this.prefijo_factura_serie);
                let errorprefijoabono = this.validarPrefijo(this.prefijo_abono_serie);

                if (errorprefijofacturaserie != "Prefijo válido") {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Prefijo factura: ' + errorprefijofacturaserie, life: 5000 });
                    return;
                }
                if (errorprefijoabono != "Prefijo válido") {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Prefijo rectificativa: ' + errorprefijoabono, life: 5000 });
                    return;
                }

                if (this.id > 0) {
                    try {
                        this.$store.dispatch('cambiarGuardando', true);
                        await api.put('lineas-facturacion/' + this.id, subidadatos);
                        this.$store.dispatch('cambiarGuardando', false);
                        this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                        
                        // Cerramos la pesta�a de origen
                        this.cerrarPestanaActual(rutaOrigen);
                    }
                    catch (error) {
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                        this.$store.dispatch('cambiarGuardando', false);
                    }
                }
                else { 
                    try {
                        await api.post('lineas-facturacion', subidadatos);
                        this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });

                        this.nombre_serie = '';
                        this.prefijo_factura_serie = '';
                        this.digitos_numero_factura = '';
                        this.prefijo_abono_serie = '';
                        this.tope_serie = '';
                        this.tope_serie_abono = '';
                        this.seleccionado = 0;
                        
                        // 1. Eliminamos la pesta�a del formulario de creaci�n (ej. /lineasfacturacion)
                        this.cerrarPestanaActual(rutaOrigen);

                        // 2. Redirigimos al registro reci�n creado (esto crear� su propia pesta�a nueva)
                        /*if (this.verifactu == 1) {
                            this.$router.push('/lineasverifactu/' + res.id);
                        } else {
                            this.$router.push('/lineasfacturacion/' + res.id);
                        }*/
                    }
                    catch (error) {
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                    }
                }
            }
        },
        cerrarPestanaActual(rutaACerrar) {
            const pathActual = rutaACerrar || this.$route.fullPath;
            
            // 1. Elimina la pesta�a espec�fica del store
            this.$store.dispatch('quitarRuta', { fullPath: pathActual });

            // 2. Si la pesta�a que cerramos es la que est� activa actualmente,
            //    navegamos a la �ltima pesta�a que quede en la lista
            if (this.$route.fullPath === pathActual) {
                const ultimasRutas = this.$store.getters.ventanas;
                if (ultimasRutas.length > 0) {
                    const siguienteRuta = ultimasRutas[ultimasRutas.length - 1].fullPath;
                    this.$router.push(siguienteRuta);
                } else {
                    this.$router.push('/escritorio');
                }
            }
        }
    },
    computed: {
        isDisabled() {
            return this.verifactu === 1 && this.id > 0
        }
    },
    mounted() {
        this.listadoEmpresas();
        this.obtenerLineas();
    },
    watch: {
        linea() {
            this.obtenerLineas();
        }
    }
}
</script>